import Profile from './Profil.vue'

export default Profile
